import styled, { css } from 'styled-components';

import { TransientProps } from '@common/types';

type withActive = TransientProps<{ active: boolean }>;
type withLoading = TransientProps<{ loading: boolean }>;
type ContainerProps = withLoading &
  withActive & {
    $deleting: boolean;
  };

export const Container = styled.li<ContainerProps>`
  ${({ theme, $active: isActive, $deleting: isDeleting }) => css`
    display: flex;
    gap: 0.625rem;
    padding: 0.75rem 0;

    > img {
      width: 2.25rem;
      height: 2.25rem;
      flex-shrink: 0;
    }

    & + & {
      border-top: 1px solid ${theme.colors.base.border};
    }

    ${!isActive &&
    css`
      pointer-events: none;
    `}

    ${isDeleting &&
    css`
      opacity: 0.4;
    `}
  `}
`;

export const Content = styled.div`
  ${({ theme }) => css`
    flex: 1;
    min-width: 0;

    > div:first-child {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      margin-bottom: 0.25rem;
      flex-wrap: wrap;

      strong {
        font-size: 0.8125rem;
        font-weight: 700;
        color: ${theme.colors.foreground[100]};
      }

      time {
        font-size: 0.75rem;
        color: ${theme.colors.foreground[40]};
      }
    }

    p {
      font-size: 0.875rem;
      line-height: 1.6;
      color: ${theme.colors.foreground[80]};
      word-break: break-word;
    }
  `}
`;

export const ModeratorOptionsContainer = styled.div`
  ${() => css`
    margin-left: auto;

    .tippy-content {
      padding: 0;
    }

    button {
      padding: 0.25rem !important;
    }
  `}
`;

export const ModeratorOptionsButton = styled.button`
  ${({ theme }) => css`
    background: none;
    white-space: nowrap;
    width: 100%;
    border-radius: 0.25rem;
    justify-content: flex-start;
    transition: 180ms ease-in-out;
    padding: 0.75rem 1rem !important;
    border: none;
    cursor: pointer;
    color: ${theme.colors.foreground[100]};

    :hover {
      background: ${theme.colors.brand.primary.default};
      color: ${theme.colors.base.text};
    }
  `}
`;
